import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrintFormType } from '../../pdf-client/pdf-request.interface';
import { PdfService } from '../../pdf-client/pdf.service';
import { LocationType } from '../../graphql-client/graphql';
import { Environment } from '../../environment';

@Component({
  selector: 'finders-ivf-dialog',
  templateUrl: './ivf-dialog.component.html',
  styleUrls: ['./ivf-dialog.component.scss']
})
export class IvfDialogComponent implements OnInit {
  public ivfForm: FormGroup;
  public result: any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<IvfDialogComponent>,
    private pdfService: PdfService,
    private env: Environment,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.result = data;
  }

  ngOnInit() {
    this.ivfForm = this.fb.group({
      physician_name: [''],
      npi: [''],
      physicianTaxID: [''],
      specialty: [''],
      siteID: [''],
      site_name: [''],
      address_one: [''],
      address_two: [''],
      city: [''],
      state: [''],
      zip_code: [''],
      phone: [''],
      fax: [''],
      office_contact: ['']
    });
  }

  public submitIvfForm() {
    const _form = this.ivfForm.value;

    const pdfRequest = {
      npi: _form.npi,
      speciality: _form.specialty,
      physicianTaxID: _form.physicianTaxID,
      siteName: _form.site_name,
      address1: _form.address_one,
      address2: _form.address_two,
      city: _form.city,
      state: _form.state,
      zipCode: _form.zip_code,
      phone: _form.phone,
      fax: _form.fax,
      officeContact: _form.office_contact,
      physicianName: _form.physician_name,
      enumPrintFormType: PrintFormType.IVF,
      locationType: <LocationType>this.result.locationType,
      productName: this.env.product,
      locationQL: {
        name: this.result.name,
        address1: this.result.address1,
        address2: this.result.address2,
        city: this.result.city,
        state: this.result.state,
        zipCode: this.result.zipCode,
        phone: this.result.phone,
        fax: this.result.fax
      }
    };

    this.pdfService
      .populatePdf(pdfRequest, `${this.env.product} IVF Form.pdf`)
      .subscribe(() => {
        this.dialogRef.close();
      });
  }
}
